import z from "zod";

export const notifyMeFormSchema = z.object({
	email: z
		.string()
		.min(1, { message: "notifyMe.fieldError.emailRequired" })
		.email({ message: "notifyMe.fieldError.emailInvalid" }),
	acceptTerms: z.literal(true, {
		message: "notifyMe.fieldError.termsRequired",
	}),
});

export type NotifyMeFormInput = z.infer<typeof notifyMeFormSchema>;

export const notifyMeAlertSchema = z.object({
	displayName: z.string(),
	displayUri: z.string(),
	brand: z.string(),
	displayImage: z.string(),
	variant: z.string(),
	excerpt: z.string(),
	description: z.string(),
	sku: z.string(),
	sizeSku: z.string(),
	ean: z.string(),
	size: z.string(),
	priceInRegion: z.string(),
	priceInRegionAmount: z.string(),
	currencyInRegion: z.string(),
	lang: z.enum(["en", "no"]),
});

export type NotifyMeAlert = z.infer<typeof notifyMeAlertSchema>;

export type NotifyMeAlertProduct = Omit<NotifyMeAlert, "size" | "sizeSku" | "ean">;

export const notifyMeSubmissionSchema = notifyMeFormSchema.extend({
	alert: notifyMeAlertSchema,
});

export type NotifyMeSubmission = z.infer<typeof notifyMeSubmissionSchema>;
